import React from "react";

export const ModeContext = React.createContext("full");



// WEBPACK FOOTER //
// ./src/components/Layout/Theme.js